import _ from "lodash";

export const SubscriptionCard = ({ subscription, subscribe }: any) => {
    const image = require('../../../assets/img/logistic.png');
    return (

        <div className="flex flex-col w-full  max-w-xs md:max-w-sm lg:max-w-sm p-4 border rounded-xl border-gray-300 bg-slate-50 shadow-md ">
            <div className="relative w-full rounded-xl overflow-hidden transition-transform duration-300 hover:scale-105 hover:shadow-lg">
                <div className="w-full h-0 pb-[50%] bg-gray-200 rounded-xl">
                    <img
                        className="absolute inset-0 w-full h-full object-fill rounded-xl"
                        src={subscription?.MediaMappings?.MediaFiles[0]?.FileMappingURL || image}
                        alt={subscription?.Name || "Subscription Image"}
                    />
                </div>
            </div>
            <div className="flex flex-col w-full mt-4 items-center">
                <div className="text-xl font-semibold text-gray-900 truncate">
                    {subscription?.Name}
                </div>
                <div className="text-gray-600 mt-2 text-sm md:text-base">
                    {subscription?.Description}
                </div>
            </div>

            <div className="w-full mt-4">
                <button className="w-full bg-primary text-light h-12 text-lg rounded-xl font-medium" onClick={() => subscribe(subscription)}>
                    Choose Program
                </button>
            </div>
        </div>

    );
};